module.exports = __webpack_public_path__ + "static/media/food.d9fe4490.jpg";